export default __webpack_public_path__ + "static/swim-22cd09b4bec619981511b11835fa2684.jpg";